// extracted by mini-css-extract-plugin
export default {"wrapper":"login-page_wrapper__g7IHv","inside":"login-page_inside__VXjJl","loginBox":"login-page_loginBox__qQUSB"};